import { RouterModule, Routes } from '@angular/router';

import { LayoutComponent } from './layout/layout.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { LoginComponent } from './login/login.component';
import { LoginGuard } from './login/login.guard';
import { NoLoginGuard } from './login/no-login.guard';

const AppRoutes: Routes = [
  { path: '', redirectTo: '/login', pathMatch: 'full' },
  { path: 'app', component: LayoutComponent, canActivate: [LoginGuard]},
  { path: 'login', component: LoginComponent, canActivate: [NoLoginGuard] },
  { path: '**', component: DashboardComponent, canActivate: [NoLoginGuard] }
];

export const AppRoutingModule = RouterModule.forRoot(AppRoutes, {useHash: true});



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts